module.exports = {"370521001":"垦利街道","370521002":"兴隆街道","370521101":"胜坨镇","370521102":"郝家镇","370521104":"永安镇","370521105":"黄河口镇","370521106":"董集镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370521.json
// module id = 1510
// module chunks = 0